import { Navigate } from 'react-router-dom';

export default function AdminRoute({ children }) {
  const token = localStorage.getItem('vizumToken');
  const user = JSON.parse(localStorage.getItem('vizumUser'));

  if (!token) {
    return <Navigate to="/login" />;
  }

  if (user?.tipo !== 'admin') {
    return <Navigate to="/home" />;
  }

  return children;
}
